import useSectionPermissions from './useSectionPermissions';
import { useEffect } from 'react';

const useSectionScopeChange = ({ scope }: { scope: ReturnType<typeof useSectionPermissions>['scope']; }) => {
    const { setScope } = useSectionPermissions();

    useEffect(() => {
        setScope(scope);

        return () => {
            setScope(undefined);
        };
    }, [scope, setScope]);
};

export default useSectionScopeChange;